// extracted by mini-css-extract-plugin
export default {"container":"vqRT0k1AUuu7OswuFquQ"};